module.exports = __webpack_public_path__ + "img/nunito-sans-v6-latin-700.1ca1c743.svg";